export function getReloadCount() {
  return parseInt(sessionStorage.getItem('reloadCount') || '0', 10);
}

export function incrementReloadCount() {
  const count = getReloadCount() + 1;
  sessionStorage.setItem('reloadCount', count.toString());

  return count;
}

export function resetReloadCount() {
  sessionStorage.removeItem('reloadCount');
}
